import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_user', JSON.stringify(data));
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(e => e.msg || JSON.stringify(e)).join(' '));
      else setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A192F] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="text-3xl tracking-[0.3em] text-white font-light">BNDV</h1>
          <p className="text-xs tracking-[0.25em] text-slate-400 mt-1">CAPITAL</p>
          <p className="text-sm text-slate-500 mt-6 uppercase tracking-wider">Admin Panel</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white/5 backdrop-blur border border-white/10 p-8" data-testid="admin-login-form">
          <div className="mb-6">
            <label className="block text-xs uppercase tracking-wider text-slate-400 mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
              className="w-full px-4 py-3 bg-white/5 border border-white/20 text-white placeholder-slate-500 focus:border-white/50 focus:ring-0 outline-none transition-colors"
              placeholder="admin@bndvcapital.com"
            />
          </div>

          <div className="mb-6">
            <label className="block text-xs uppercase tracking-wider text-slate-400 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="w-full px-4 py-3 bg-white/5 border border-white/20 text-white placeholder-slate-500 focus:border-white/50 focus:ring-0 outline-none transition-colors"
              placeholder="Enter password"
            />
          </div>

          {error && (
            <p className="text-red-400 text-sm mb-4" data-testid="admin-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3 bg-white text-[#0A192F] text-sm uppercase tracking-wider font-medium hover:bg-slate-100 transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-xs text-slate-500 hover:text-slate-300 uppercase tracking-wider transition-colors">
            Back to Website
          </a>
        </div>
      </div>
    </div>
  );
}
